// Keep the original English slot keys/URLs. Language variants are independent
// uploads, not translations or duplicate references to the same video.
export const WORKER_TUTORIAL_VARIANTS = {
  worker: { en: "worker", es: "worker-es" },
  manager: { en: "manager", es: "manager-es" },
};

export const workerTutorialRole = section => Object.keys(WORKER_TUTORIAL_VARIANTS)
  .find(role => Object.values(WORKER_TUTORIAL_VARIANTS[role]).includes(section));

export const selectWorkerTutorial = (role, language, available) => {
  const variants = WORKER_TUTORIAL_VARIANTS[role];
  if (!variants) return null;
  const preferred = language === "es" ? "es" : "en";
  const fallback = preferred === "es" ? "en" : "es";
  if (available.has(variants[preferred])) return variants[preferred];
  return available.has(variants[fallback]) ? variants[fallback] : null;
};